import styled from "styled-components";

export const PayWrapper = styled.div`
width: 85%;
display: flex;
flex-direction: column;
align-items: center;
`
export const FormHeader = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
margin-bottom: 61px;
`
export const Title = styled.div`
width: 100%;
font-style: normal;
font-weight: var(--general-header-font-weight);
font-size: var(--general-header-font-size);
line-height: 24px;
color: var(--font-color-blue002e5c);
text-align: center;
margin-bottom: 15px;
margin-top: 30px;
`
export const PayForm = styled.div`
width: 80%;

`
export const Description = styled.div`
width: 454px;
text-align: center;
color: var(--font-color-blue002e5c);
`
export const Label = styled.label`
font-weight: var(--general-small-label-font-weight);
font-size: var(--general-small-label-font-size);
line-height: 18px;
color: var(--font-color-blue002e5c);
padding-left: 11px;
`
export const RadioWrapper = styled.div`
display: flex;
justify-content: left;
text-align: left;
align-items: center;
margin-left: 11px;

`
export const RadioLabel = styled.label`
color: var(--font-color-blue002e5c);
font-style: normal;
font-weight: var(--general-large-body-font-weight);
font-size: var(--general-large-body-font-size);
line-height: 24px;
padding-right: 32px;

`
